import React from 'react';
import { DropdownButton } from 'react-bootstrap';
import { getOrgTermsContent } from '../../content/utils.js';
import {
  AddParentPortfolioLink,
  AddPortfolioLink,
  NewProjectLink,
} from '../links/index.jsx';
import ProjectIcon from '../icons/ProjectIcon.jsx';
import PortfolioIcon from '../icons/PorfolioIcon.jsx';
import ParentPortfolioIcon from '../icons/ParentPorfolioIcon.jsx';
import CustomMenuItem from '../CustomMenuItem.jsx';

const ProjectsActionDropdown = ({ title, position }) => {
  return (
    <div className={`actions ${position || ''}`}>
      <DropdownButton
        bsStyle="success"
        title={title || 'Add'}
        id="projects-action-dropdown"
      >
        <AddParentPortfolioLink>
          <CustomMenuItem>
            <ParentPortfolioIcon />
            <span>&nbsp; {getOrgTermsContent('parentPortfolio')}</span>
          </CustomMenuItem>
          <CustomMenuItem divider />
        </AddParentPortfolioLink>
        <AddPortfolioLink>
          <CustomMenuItem>
            <span className="flex">
              <PortfolioIcon />
              <span>&nbsp; {getOrgTermsContent('portfolio')}</span>
            </span>
          </CustomMenuItem>
          <CustomMenuItem divider />
        </AddPortfolioLink>

        <NewProjectLink>
          <CustomMenuItem>
            <span className="flex">
              <ProjectIcon />
              <span>&nbsp;&nbsp; {getOrgTermsContent('project')}</span>
            </span>
          </CustomMenuItem>
          <CustomMenuItem divider />
        </NewProjectLink>
      </DropdownButton>
    </div>
  );
};

export default ProjectsActionDropdown;
